export default __webpack_public_path__ + "static/media/shippedIcon.b9bb2390.svg";